import * as PropTypes from "prop-types";
import styled from "styled-components";

function noop() {}

export default function LinkButton({
  onClick,
  children,
  underline,
  disabled,
  id,
  style,
}) {
  return (
    <ButtonStyled
      id={id}
      onClick={disabled ? noop : onClick}
      underline={underline}
      type="button"
      style={style}
      data-cy="goBackToDashBoard"
    >
      {children}
    </ButtonStyled>
  );
}

const ButtonStyled = styled.button`
  background-color: transparent;
  color: #747474;
  padding: 9px;
  font-size: 16px;
  outline: none;
  border: 1px solid transparent;
  text-decoration: underline;
  ${({ underline }) => underline && "text-decoration: underline"};
  border-radius: ${({ theme }) => theme.borderRadius};

  /* &:first-child {
    padding-left: 0px;
  } */
  transition: border 0.3s, background-color 0.3s;

  &:focus {
    border: 1px solid ${({ theme }) => theme.borderColor};
    background-color: ${({ theme }) => theme.hoverColor};
    padding: 9px;
  }

  &:hover {
    color: #2a2a2a;
    cursor: pointer;
    transition: color 0.2s;
  }
`;

LinkButton.propTypes = {
  disabled: PropTypes.bool,
  children: PropTypes.any,
  onClick: PropTypes.func.isRequired,
  underline: PropTypes.bool,
  id: PropTypes.string,
  style: PropTypes.any,
};
